// organize-imports-ignore
import { FC } from 'react';
// third-party
import { Box, Button } from '@mui/material';
import useAuth from 'hooks/useAuth';
// project imports
import { useMutation } from 'react-query';
import { getErrorMessage } from 'utils/stringUtils';
import { useSnackbar } from 'notistack';
import { FormattedMessage, useIntl } from 'react-intl';
import BasicDialog from 'views/components/modals/BasicDialog';

export type Props = {
  rescheduleEvent: any;
  onClose: Function;
  refetchAppointments: Function;
};

const RescheduleConfirmationDialog: FC<Props> = ({ rescheduleEvent, onClose, refetchAppointments }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { request } = useAuth();
  const intl = useIntl();

  const rescheduleAppointmentMuatation = useMutation(
    (variables: any) => request.post(`/appointments/${variables.event_id}/reschedule`, { date: variables.date, message: '' }),
    {
      onSuccess() {
        enqueueSnackbar(intl.formatMessage({ defaultMessage: 'Appointment Rescheduled!' }), { variant: 'success' });
        refetchAppointments();
        onClose();
      },
      onError(e: any) {
        enqueueSnackbar(getErrorMessage(e), { variant: 'error' });
      }
    }
  );

  return (
    <BasicDialog
      open
      onClose={() => onClose()}
      maxWidth="xs"
      actions={
        <>
          <Button
            variant="contained"
            onClick={() => {
              rescheduleAppointmentMuatation.mutate(rescheduleEvent.variables);
            }}
            disabled={rescheduleAppointmentMuatation.isLoading}
          >
            <FormattedMessage defaultMessage="Yes" />
          </Button>
          <Button variant="contained" onClick={() => onClose()} disabled={rescheduleAppointmentMuatation.isLoading}>
            <FormattedMessage defaultMessage="No" />
          </Button>
        </>
      }
    >
      <Box sx={{ py: 1 }}>
        <FormattedMessage defaultMessage={'Are you sure you want to reschedule the session?'} />
      </Box>
    </BasicDialog>
  );
};

export default RescheduleConfirmationDialog;
